var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,20.9v-3c0-.6.2-1.2.5-1.7s.7-.9,1.3-1.2c.9-.5,2-.9,3.1-1.2,1.2-.3,2.4-.5,3.8-.5h.4c.1,0,.2,0,.3,0-.5,1.3-.7,2.6-.6,3.9,0,1.3.5,2.5,1.3,3.6H1.5ZM10.2,12.2c-1.2,0-2.2-.4-3.1-1.3-.8-.8-1.3-1.9-1.3-3.1s.4-2.2,1.3-3.1c.8-.8,1.9-1.3,3.1-1.3s2.2.4,3.1,1.3c.8.8,1.3,1.9,1.3,3.1s-.4,2.2-1.3,3.1-1.9,1.3-3.1,1.3ZM15.5,19.3l1.9-1.9,1.9,1.9.8-.8-1.9-1.9,1.9-1.9-.8-.8-1.9,1.9-1.9-1.9-.8.8,1.9,1.9-1.9,1.9.8.8ZM17.5,22c-.7,0-1.4-.1-2.1-.4s-1.2-.7-1.7-1.1-.9-1.1-1.1-1.7-.4-1.4-.4-2.1.1-1.4.4-2.1.7-1.2,1.1-1.7,1.1-.9,1.7-1.1,1.4-.4,2.1-.4,1.4.1,2.1.4,1.2.7,1.7,1.1.9,1.1,1.1,1.7.4,1.4.4,2.1-.1,1.4-.4,2.1-.7,1.2-1.1,1.7-1.1.9-1.7,1.1-1.4.4-2.1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveResource);
export default __webpack_public_path__ + "static/media/remove-resource.f15c52222627b87635017fc619ea305d.svg";
export { ForwardRef as ReactComponent };